<template>
    <div>
        <home></home>
        <validate></validate>
    </div>
</template>

<script>
import Home from "@/views/home";
import Validate from "@/components/Validate";

export default {
    components: {Home, Validate}
}
</script>

<style scoped>

</style>
